import { render, staticRenderFns } from "./ExhibitPrice.vue?vue&type=template&id=33db67f0&scoped=true&"
import script from "./ExhibitPrice.vue?vue&type=script&lang=js&"
export * from "./ExhibitPrice.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitPrice.vue?vue&type=style&index=0&id=33db67f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33db67f0",
  null
  
)

export default component.exports